module.exports = __webpack_public_path__ + "597aa0bc7594baf049d435dd6602a84a.png";